import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { paymentTypeTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const addPaymentType = (
  data: paymentTypeTypes.AddPaymentTypeData
): Promise<{ paymentType: paymentTypeTypes.PaymentType }> => {
  return axios.put('/payment-types', data);
};

type AddPaymentTypeOptions = {
  onSuccess: () => void;
  config?: MutationConfig<typeof addPaymentType>;
};

export function useAddPaymentType({ config = {}, onSuccess }: AddPaymentTypeOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['payment-types']);
      toasts.loadingToast.success('add-payment-type', 'Payment type added successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('add-payment-type', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('add-payment-type', 'Adding payment type...');
      config.onMutate?.(...args);
    },
    mutationFn: addPaymentType,
  });
}
